import {useEffect, useState} from "react";
import {PricingContext} from "./context";

export const PricingContextProvider = (props) => {
  const {children} = props;
  const [pricing, setPricing] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      fetch("https://cloudmylab.com/api/pricing", {
        method: "POST",
      })
        .then(async (res) => {
          const responseJson = await res.json();
          const data = responseJson.result;
          setPricing(data?.cloudmylab || []);
        })
        .catch(() => {
          setPricing([]);
        })
        .finally(() => setLoading(false));
    };
    getData();
  }, []);

  return (
    <PricingContext.Provider
      value={{
        loading,
        pricing,
      }}
    >
      {children}
    </PricingContext.Provider>
  );
};
